var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { generateUUID, getLanguageFromStorage } from "syf-js-utilities";
import { useTranslation } from "react-i18next";
import { PrivateEarningsContainer, PrivateEarningsDisclaimer, PrivateEarningsDisclaimerContainer, PropositionsContainer, Title, } from "./subcomponents";
import PropositionsCard from "../PropositionCard";
import useRewards from "../../../hooks/useRewards";
var JCrewPrivateCardEarnings = function (_a) {
    var _b, _c, _d;
    var className = _a.className;
    var t = useTranslation().t;
    var language = getLanguageFromStorage();
    var _e = useRewards(), rewardsExperience = _e.rewardsExperience, clientId = _e.clientId;
    var disclaimer = (_b = rewardsExperience === null || rewardsExperience === void 0 ? void 0 : rewardsExperience[clientId].PRIVATE_LABEL[language].disclaimer) !== null && _b !== void 0 ? _b : "";
    var propositions = (_c = rewardsExperience === null || rewardsExperience === void 0 ? void 0 : rewardsExperience[clientId].PRIVATE_LABEL[language].propositions) !== null && _c !== void 0 ? _c : [];
    var howToEarnPointsHeader = (_d = rewardsExperience === null || rewardsExperience === void 0 ? void 0 : rewardsExperience[clientId].howToEarnPointsHeader) !== null && _d !== void 0 ? _d : "";
    return (_jsxs(PrivateEarningsContainer, { children: [_jsx(Title, __assign({ className: className }, { children: t(howToEarnPointsHeader) })), _jsx(PropositionsContainer, { children: propositions.map(function (proposition) { return (_jsx(PropositionsCard, { heading: proposition.heading, points: proposition.points, description: proposition.description }, "snapshot-".concat(generateUUID()))); }) }), _jsx(PrivateEarningsDisclaimerContainer, { children: _jsx(PrivateEarningsDisclaimer, { children: disclaimer }) })] }));
};
export default JCrewPrivateCardEarnings;
